module.exports = __webpack_public_path__ + "static/media/FontAwesome.87d8ca3d.otf";